import { useTranslation } from 'react-i18next'

const useModalResources = (resources) => {
    const { t } = useTranslation()
      const selectElementOfType = type => resources.find(resource => resource.resource_type === type)?.resource_value || ''
      const saleScript = selectElementOfType('sale_script')
      const learningLink = selectElementOfType('learning_link')
      const emailTemplateLink = selectElementOfType('email_template_link')
      const objections = selectElementOfType('objections')
    return {t, saleScript, learningLink, emailTemplateLink, objections}
}

export default useModalResources
